// BeEco - Recently Viewing: saves last product/collection to localStorage.
// Display is handled by the beeco-rv-top-strip and beeco-rv-bottom-strip sections.

(function () {
  var LS_PRODUCT = 'beeco:rv:product';
  var LS_COLLECTION = 'beeco:rv:collection';

  var path = window.location.pathname;
  var pageTitle = document.title
    .replace(/\s[\u2013\u2014-].*$/, '')
    .replace(/\s*\|.*$/, '')
    .replace(/\s*-\s*BeEco.*$/i, '')
    .trim();

  if (/^\/products\//.test(path)) {
    try { localStorage.setItem(LS_PRODUCT, JSON.stringify({ url: path, title: pageTitle })); } catch (e) {}
  } else if (/^\/collections\//.test(path) && path !== '/collections/all') {
    try { localStorage.setItem(LS_COLLECTION, JSON.stringify({ url: path, title: pageTitle })); } catch (e) {}
  }
})();